const FormRow = ({ type, name, value, handleChange, labelText, min, maxLength }) => {
    return (
        <div className='form-row'>
            <label htmlFor={name} className='form-label'>
                {labelText || name}
            </label>

            <input
                type={type}
                value={value}
                name={name}
                min={min ? min : null}
                onChange={handleChange}
                maxLength={maxLength ? maxLength : null}
                className="form-input" />
        </div>
    );
}

export default FormRow;